import axios from 'axios';

import { handleError } from '@/shared/services/api';

let familySubsidyId = null;

export default {
  baseUrl(id) {
    if (id)
      return `${window.api_url}/organization/family_subsidies/${familySubsidyId}/household_members/${id}`;

    return `${window.api_url}/organization/family_subsidies/${familySubsidyId}/household_members`;
  },

  create(householdMember) {
    return axios.post(this.baseUrl(), { household_member: householdMember }).catch(handleError);
  },

  destroy(id) {
    return axios.delete(this.baseUrl(id)).catch(handleError);
  },

  get(id) {
    return axios.get(this.baseUrl(id)).catch(handleError);
  },

  index(filters) {
    return axios.get(this.baseUrl(), { params: filters }).catch(handleError);
  },

  remove(id) {
    return axios.patch(`${this.baseUrl(id)}/remove`).catch(handleError);
  },

  setFamilySubsidyId(id) {
    familySubsidyId = id;
  },

  update(householdMember) {
    return axios
      .patch(this.baseUrl(householdMember.id), { household_member: householdMember })
      .catch(handleError);
  },
};
